import React, { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useAlert } from 'react-alert';
import styled from 'styled-components';
import { GetApi } from '../../Common/ApiAxios';
import { SetLoadSpinner } from '../../Common/Slice/LoadSpinnerSlice';
import { BoardBaseFormRow, BoardBaseFormRowScroll } from '../Wrap/BoardBaseWrap';
import Search from './Search';
import SideSubMenu from '../SideSubMenu';
import PerformanceDaily from './PerformanceDaily';
import * as LogisticUtility from '../../Common/Utilties/LogisticUtility'
import { useLocation } from 'react-router-dom'
import {onExportCsvFile,onExportSjisCsvFile} from '../../Common/Utilties/ExportUtility'
import { MultipartApi } from '../../Common/ApiAxios';
import IconGearImg from '../../../image/gear-icon.png'
import ShippingCdDialog from './Atoms/ShippingCdDialog'
const DefaultUrl = '/api/masterManagement/makeShippingSchedule';

const ContentWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  text-align: center;
  overflow-y: hidden;
  overflow-x: hidden;
`;

const ItemCount = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 60px;
  font-size: 18px;

  img {
    width: 17px;
    height: 17px;
    margin-right: 20px;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
`;

const VASMasterMakeShippingSchdule = () => {
  const { loginUserInfo } = useSelector(state => state);
  const dispatch = useDispatch();
  const alert = useAlert();
  const searchDateRef = useRef(null);
  const [viewFunction, setViewFunction] = useState(false);
  const [convertData, setConvertData] = useState([]);
  const [convertOwnerData, setConvertOwnerData] = useState([]);

  const [fileData, setFileData] = useState([
    {file:undefined,type:0,fileName:''},
    {file:undefined,type:1,fileName:''},
  ]);
  const [shippingData, setShippingData] = useState([]);
  const history = useLocation(); 
  const hisState = history.state
  const baseId = history.state&&history.state.baseId?history.state.baseId:2

  // Handlers
  const onClickFunction = () => setViewFunction(!viewFunction);
  const onCloseFunction = () => setViewFunction(false);

  // Fetch data functions
  const getConvertOwnerCdList = async (isLoadSpinner) => {
      if (isLoadSpinner) dispatch(SetLoadSpinner(true));
  
      const apiUrl = `${DefaultUrl}/getCovertOwnerCd/${baseId}`;
  
      const result = await GetApi(apiUrl);
      if (isLoadSpinner) dispatch(SetLoadSpinner(false));
  
      if (result.errorDetail) {
        alert.error('該当データがありません（変換表の取得）');
        setConvertOwnerData([]); // データがない場合もリセット
      } else {
        console.log(result.data)
        setConvertOwnerData(result.data); // 初期状態では全データを表示
      }
  };
  // Fetch data functions
  const getConvertShippingCdList = async (isLoadSpinner) => {
    if (isLoadSpinner) dispatch(SetLoadSpinner(true));

    const apiUrl = `${DefaultUrl}/getConvertShippingCdList/${baseId}`;

    const result = await GetApi(apiUrl);
    if (isLoadSpinner) dispatch(SetLoadSpinner(false));

    if (result.errorDetail) {
      alert.error('該当データがありません（変換表の取得）');
      setConvertData([]); // データがない場合もリセット
    } else {
      console.log(result.data)
      setConvertData(result.data); // 初期状態では全データを表示
    }
  };
  // Fetch data functions
  const getShippingDataList = async (isLoadSpinner) => {
    if (isLoadSpinner) dispatch(SetLoadSpinner(true));
    var date = new Date(searchDateRef.current);

    date.setDate( date.getDate() + 1);
    var deliveryDate = LogisticUtility.getStringFromDate(date, 'YYYY-MM-DD')  
    const apiUrl = `${DefaultUrl}/getShippingSumDataList/${baseId}/${deliveryDate}`;

    const result = await GetApi(apiUrl);
    if (isLoadSpinner) dispatch(SetLoadSpinner(false));

    if (result.errorDetail) {
      alert.error('該当データがありません（変換表の取得）');
      setShippingData([]); // データがない場合もリセット
    } else {
      console.log(result.data)
      setShippingData(result.data); // 初期状態では全データを表示
    }
  };
  // `Search` コンポーネントから渡される検索条件を基にデータをフィルタリング
  const handleSearch = (filters) => {
  };
  // 種まき予定データのCSVファイルを作成
  const onExport = async(title) => {
    var data = '';
    SetLoadSpinner(true);
    const filePromises = fileData.map(async(file)=>{
      return new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.readAsText(file.file,'sjis');
        reader.onload = async function(event) {
          var csvData = '';
          if(!event.target) return
          var result = event.target.result;
          if(result==null) return
          try{
            // 改行ごとに配列化
            let lines = result.toString().split(/\r\n|\n/);
            // 1行ごとに処理
            for (let i = 0; i < lines.length-1; i++) {
              let cells = lines[i].replaceAll('"','').split(",");
              cells[19]=Number(cells[19]).toString()
              for (let j = 0; j < convertData.length; j++) {
                if(cells[9]== `${convertData[j].srcShippingCd}`){
                  cells[9] = `${convertData[j].dstShippingCd}`
                  break;
                }
              }
              for (let j = 0; j < convertOwnerData.length; j++) {
                if(cells[9]== `${convertOwnerData[j].shippingCd}`){
                  cells[4] = `${convertOwnerData[j].ownerCd}`
                  break;
                }
              }
              data += (cells.join(',')+'\n')
              csvData += (cells.join(',')+'\r\n')
            }
            resolve(csvData);
          }catch(e){
            console.log(e)
            alert.error('ファイル読み込みの途中でエラーになりました。');
            reject(e)
            data = ''
          }finally{
          }
        };
        reader.onerror = function(e) {
          console.log('ファイルが読み込めませんでした。 ' + file.fileName);
          alert.error('ファイルが読み込めませんでした。');
          resolve(e);
        };
      })
    })
    // Wait for all promises to be resolved
    await Promise.all(filePromises).then((values) => {
      onExportSjisCsvFile(values.join(''),title)
    }).catch(()=>{
      return ''
    }).finally(
    );
  };

  // 作成ボタンのクリックイベント
  const onExportData = async() => {
    var makeDate = new Date(searchDateRef.current);
    makeDate.setDate(makeDate.getDate() - 1);
    var title = LogisticUtility.getStringFromDate(makeDate, 'YYYYMMDD')  
    title += '_種まき予定データ'
    // 1行ごとに処return res.join('');理
    for (let i = 0; i < fileData.length; i++) {
      if(!fileData[i].file || fileData[i].file==''){
        alert.error(`変換する尾西の種まき予定データ${fileData[i].type?'NDF':'イニシオ'}ファイルを選択してください`);
        return
      }
    }
    await onExport(title)
   
    return
  };
  useEffect(() => {
    getConvertShippingCdList();
    getConvertOwnerCdList();
    getShippingDataList(true);
  }, [searchDateRef.current]);
  const onChange=(date)=>{
    searchDateRef.current = date
  }
  // `Clear` 出荷指示削除処理
  const handleClear =  async(type) => {
    var date = new Date(searchDateRef.current)
    date.setDate( date.getDate() + 1);
    var searchDate = LogisticUtility.getStringFromDate(date, 'YYYY-MM-DD') 
    var param =
      {
        baseId: baseId,
        deliveryDate: searchDate,
        type: type 
      }

      dispatch(SetLoadSpinner(true));

      const apiUrlClear = `${DefaultUrl}/clear`;
      console.log(param)
      var result1 = {};
      {
        const submitData = new window.FormData()
        submitData.append('formData', new window.Blob([JSON.stringify(param)], { type: 'application/json' }))
        result1 = await MultipartApi(apiUrlClear,'PUT',submitData,param);
      }

      dispatch(SetLoadSpinner(false));
      if(result1.errorDetail)
      {
        alert.error('出荷指示の削除に失敗しました。');
      }else{
        alert.info('出荷指示の削除に成功しました。');
        getShippingDataList(true);
      }
  };
  // `Make` 出荷指示削除作成
  const handleMake =  async(type) => {
      var date = new Date(searchDateRef.current)
      date.setDate( date.getDate() + 1);
      var searchDate = LogisticUtility.getStringFromDate(date, 'YYYY-MM-DD') 
      var param =
        {
          baseId: baseId,
          deliveryDate: searchDate,
          type: type 
        }
  
        dispatch(SetLoadSpinner(true));
  
        const apiUrlClear = `${DefaultUrl}/makeShipping`;
        console.log(param)
        var result1 = {};
        {
          const submitData = new window.FormData()
          submitData.append('formData', new window.Blob([JSON.stringify(param)], { type: 'application/json' }))
          result1 = await MultipartApi(apiUrlClear,'PUT',submitData,param);
        }
  
        dispatch(SetLoadSpinner(false));
        if(result1.errorDetail)
        {
          alert.error('出荷指示の削除に失敗しました。');
        }else{
          alert.info('出荷指示の削除に成功しました。');
          getShippingDataList(true);
        }
  };

  //ダイアログ用
  const [open,setOpen] = useState(false);
  const onClickOpen=()=>{
    setOpen(true)
  }
  const onCloseFunc=()=>{
    setOpen(false)
  }

  if (!searchDateRef.current) {
    searchDateRef.current = LogisticUtility.getStringFromDate(new Date(), 'YYYY-MM-DD')  
  }
  return (
    <>
      <Search
        searchDateRef={searchDateRef}
        onClickFunction={onClickFunction}
        onCloseFunction={onCloseFunction}
        viewFunction={viewFunction}
        onSearch={handleSearch}
        onChange={onChange}
      />

      <BoardBaseFormRow>
        <SideSubMenu height={'84vh'} planExisit={true} />
        <BoardBaseFormRowScroll>
          <ContentWrap>
            <ItemCount>
            <img alt='設定' src={IconGearImg} width="24px" height="24px" style={{marginTop: '4px',marginLeft: 'auto', cursor: 'pointer'}} onClick={onClickOpen} />
            </ItemCount>
            <PerformanceDaily
              personalList={fileData}
              shippingSumList={shippingData}
              onExport={onExportData}
              onClear={handleClear}
              onCreate={handleMake}
            />
          </ContentWrap>
        </BoardBaseFormRowScroll>
      </BoardBaseFormRow>
      <ShippingCdDialog 
       onCloseFunc={onCloseFunc}  
       open={open}
       onResearch={getConvertShippingCdList}
       convertData={convertData}
       baseId={baseId}
      />
    </>
  );
};

export default VASMasterMakeShippingSchdule;
